<template>
    <form ref="form" class="form">
        <b-form-group>
            <b-row>
                <b-col sm="4"> <label for="accountNo">  {{$t('defination.zoneTypes.zoneType')}} </label> </b-col>
                <b-col sm="8"> <b-form-input id="accountNo" v-model="type" placeholder="Zone Tipini Giriniz" /></b-col>
            </b-row>
            <b-row>
                <b-col sm="4"> <label for="accountNo"> {{$t('defination.zoneTypes.img')}} </label> </b-col>
                <b-col sm="8"> <b-form-file v-model="file" ref="file-input" class="mb-2"></b-form-file> </b-col>
            </b-row>
        </b-form-group>
    </form>
</template>

<script>
    export default {
        name: "ZoneType",
        props:{
            data: Object,
            modalName: String,
            modalEvent: Function,
            save: Boolean,
            saveState: Function
        },
        data: function(){
            return {
                type: this.data ? this.data.name : ""
            }
        },
        watch:{
            save: async function(data){
                if(data){
                    let val = {
                        name: this.type,
                    }
                    
                    switch(this.modalName){
                        case "add":
                            await this.$store.dispatch('addZoneTypes', val)
                            break;  
                        case "edit":
                            val.id = this.data.id
                            await this.$store.dispatch('editZoneTypes', val)
                            break;  
                    }
                    if(this.$store.getters.getStatus.status == "Success"){
                        this.$store.dispatch('listZoneTypes')
                        this.clearForm()
                    }else{
                        this.errMsg = i18n.t('general.addErrMsg')
                    }
                }
                this.saveState(false)
            },
            data: function (val){
                this.type = val.name
            },
        },
         methods:{
                clearForm(){
                    this.type = ""
                    this.modalEvent(false)
                }
            }
    }
</script>

<style lang="css" scoped > 
    @import "../styles/modalForm.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Defination/modals/ZoneTypeForm.vue